














import GoalSurveyType from "@/api/dataSource/api/Spirit/Entities/User/GoalSurveyType";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import GoalSurveyModel from "./models/goal-survey.modes";
@Component({
  name: "goal-survey-statistics",
})
export default class GoalSurveyStatisticsComponent extends Vue {
  /** Статистика цели использования приложения */
  statistics: Array<GoalSurveyModel> = new Array<GoalSurveyModel>();
  /** Количество пользователей */
  NumberOfUsers: number = 0;

  async created() {
    // Инициализируем цели использования приложения
    this.initGoalSurveyStatistics();
    // Получаем статистику по каждой цели использования приложения
    await this.getGoalSurveyStatisticsAsync();
  }

  /** Инициализируем цели использования приложения */
  initGoalSurveyStatistics() {
    this.statistics = new Array<GoalSurveyModel>();
    Object.keys(GoalSurveyType).forEach((key) => {
      if (Number(key) == 0 || Number(key)) {
        this.statistics.push(
          new GoalSurveyModel({ Id: Number(key), UsagePercentage: 0 })
        );
      }
    });
  }

  /** Получаем статистику по каждой цели использования приложения  */
  async getGoalSurveyStatisticsAsync() {
    try {
      let statistics =
        await this.$api.StatisticsService.getGoalSurveyStatisticsAsync();
      if (statistics) {
        this.NumberOfUsers = statistics.NumberOfUsers;
        for (let i = 0; i < this.statistics.length; i++) {
          let existItem = statistics.GoalSurveyStatistics.find(
            (_) => this.statistics[i].Id == _.Id
          );
          if (existItem)
            this.statistics[i].UsagePercentage = Number(
              existItem.UsagePercentage
            ).toFixed(2);
        }
      }
    } finally {
    }
  }
}
